import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import productsData from "../data/products.json";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import seoFriendlySlug from "../utils/seoFriendlySlug";

const Category = () => {
  const isUAEPath = window.location.pathname.startsWith("/uae");
  const currentLocation = useLocation();

  const basePath = currentLocation.pathname.startsWith("/uae") ? "/uae" : "/";
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 1, rotate: -5 },
    visible: { opacity: 1, scale: 1, rotate: 0, transition: { duration: 0.5 } },
    hover: { scale: 1, rotate: 5, transition: { duration: 0.3 } },
  };

  const { category } = useParams();
  const decodeCategoryName = category.replace(/-/g, " ");
  const formattedCategoryName = decodeCategoryName.toLowerCase().replace(/\s+/g, '-');

  const [categoryData, setCategoryData] = useState(null);
  const navigate = useNavigate();



  useEffect(() => {
    const foundCategory = productsData.products.find(
      (product) =>
       {
        
        return(
          product.categoryName.toLowerCase() === decodeCategoryName.toLowerCase()
        )
       }
    );
    setCategoryData(foundCategory);
  }, [decodeCategoryName]);

  // changed url format

  // const handleSubcategoryClick = (subcategoryName) => {
  //   const encodedSubcategory = encodeURIComponent(subcategoryName);
  //   console.log(`${basePath}market-place/${decodeCategoryName}/${encodedSubcategory}`)
  //   navigate(`${basePath}market-place/${decodeCategoryName}/${encodedSubcategory}`);
  // };

  const handleSubcategoryClick = (subcategoryName) => {
    // Replace spaces with hyphens & ensure slashes are also converted
    const cleanedSubcategory = subcategoryName.toLowerCase().replace(/\s+/g, '-').replace(/\//g, '-');
  
    // console.log(`${basePath}market-place/${formattedCategoryName}/${cleanedSubcategory}`);
  
    navigate(`${basePath}market-place/${seoFriendlySlug(formattedCategoryName)}/${seoFriendlySlug(cleanedSubcategory)}`);
  };
  

  const [preloadedImages, setPreloadedImages] = useState({});

  // Use require.context to dynamically import images

  useEffect(() => {
    if (categoryData && categoryData.subCategories) {
      const images = {};
      categoryData.subCategories.forEach((subCategory) => {
        try {
          // Use require dynamically for each image path
          const imageSrc = require(`../assets/products/${subCategory.subimage}`);
          images[subCategory.subCategoryName] = imageSrc;
        } catch (error) {
          console.error(`Error loading image: ${subCategory.subimage}`, error);
        }
      });
      setPreloadedImages(images);
    }
  }, [categoryData]);

  return (
    <div className="container mt-4">
      <div className="mb-4">
        <Link to={`${basePath}market-place`} onClick={scrollToTop}>
          <span className="font-weight-bold" style={{ fontSize: "1.2rem" }}>
            Market Place
          </span>
        </Link>
        <span className="font-weight-bold"> | </span>
        <Link to={`${basePath}market-place/${category}`} onClick={scrollToTop}>
          <span style={{ color: "#f14144" }}>{decodeCategoryName}</span>
        </Link>
      </div>

      <h1 className="text-center text-danger mb-4">{decodeCategoryName}</h1>

      <div className="row">
        {categoryData && categoryData.subCategories ? (
          categoryData.subCategories.map((subCategory, index) => (
            <div className="col-lg-4 col-md-6 mb-4" key={index}>
              <motion.div
                className="card h-100"
                initial="hidden"
                whileInView="visible"
                whileHover="hover"
                variants={cardVariants}
                viewport={{ once: false }}
                onClick={() => {
                  scrollToTop();
                  handleSubcategoryClick(subCategory.subCategoryName);
                }}
                style={{
                  transform: "none",
                  background: "rgba(229, 229, 226, 0.4)", // Semi-transparent background
                  backdropFilter: "blur(10px)", // Glass effect with blur
                  WebkitBackdropFilter: "blur(10px)", // Safari support
                  border: "1px solid rgba(255, 255, 255, 0.2)", // Light border to enhance effect
                  borderRadius: "10px", // Rounded corners
                }}
              >
                <div
                  className="p-0 card-img-top"
                  style={{
                    backgroundImage: preloadedImages[
                      subCategory.subCategoryName
                    ]
                      ? `url(${preloadedImages[subCategory.subCategoryName]})`
                      : "none", // Fallback if image isn't preloaded yet
                    height: "200px", // Set height of the image container
                    width: "100%", // Make sure the width is set correctly
                    backgroundSize: "cover", // Ensure the image covers the container
                    backgroundPosition: "center", // Center the image
                    display: preloadedImages[subCategory.subCategoryName]
                      ? "block"
                      : "none", // Only show once the image is loaded
                  }}
                ></div>
                <div className="card-body">
                  <h5
                    className="card-title text-center"
                    style={{ color: "black" }}
                  >
                    {subCategory.subCategoryName}
                  </h5>
                </div>
              </motion.div>
            </div>
          ))
        ) : (
          <p className="text-center">No subcategories available.</p>
        )}
      </div>
    </div>
  );
};

export default Category;
